import React from "react";

import InfoModal from "./InfoModal";

const FinancingDetailsOverlay = ({
  title,
  financingData,
  buttonColor = "secondary",
  dataTestValue,
  buttonText = "Details zum Leasing",
  alwaysOnUnderline = false,
}) => (
  <InfoModal
    title={title}
    buttonText={buttonText}
    buttonColor={buttonColor}
    dataTestValue={dataTestValue}
    withIcon={false}
    alwaysOnUnderline={alwaysOnUnderline}
  >
    {financingData}
  </InfoModal>
);

export default FinancingDetailsOverlay;
